import React from "react";
import { ScoreLevel, getScoreLevelColor } from "../../utils/helper";

type ScoreBadgeProps = {
  level: ScoreLevel;
  showText?: boolean; // Optional prop to show/hide text (default: true)
  size?: number; // Optional prop for dot size in pixels (default: 10)
};

/**
 * Reusable Score Badge Component
 * Displays a colored circle with optional score level text
 * - Green for High
 * - Yellow/Orange for Medium
 * - Red for Low
 */
const ScoreBadge: React.FC<ScoreBadgeProps> = ({ level, showText = true }) => {
  if (!level) return null;

  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
      <div
        style={{
          width: "18px",
          height: "18px",
          borderRadius: "50%",
          backgroundColor: getScoreLevelColor(level),
          flexShrink: 0,
        }}
      />
      {showText && <span>{level}</span>}
    </div>
  );
};

export default ScoreBadge;
